import React from 'react';
import { ArrowUpRight, Award, BookOpenText, FolderKanban, Github } from 'lucide-react';

const proofPoints = [
  {
    label: 'PRACTICE',
    title: 'Architecture work',
    description: 'Cloud-native foundations, OpenShift operations, and repeatable delivery patterns.',
    href: '#projects',
    Icon: FolderKanban,
  },
  {
    label: 'WRITING',
    title: 'Engineering notes',
    description: 'Published thinking on platforms, automation, and the decisions behind them.',
    href: '/blogs',
    Icon: BookOpenText,
  },
  {
    label: 'EVIDENCE',
    title: 'Credentials & code',
    description: 'Professional certifications and public repositories to explore in context.',
    href: '#certifications',
    Icon: Award,
  },
];

export default function MissionControlRail() {
  return <nav className="mission-control-rail" aria-label="Portfolio evidence">
    {proofPoints.map(({ label, title, description, href, Icon }) => (
      <a className="mission-control-card" href={href} key={title} data-pointer-label="Open">
        <span className="mission-control-label"><Icon size={14} aria-hidden="true" /> {label}</span>
        <span className="mission-control-title">{title}<ArrowUpRight size={16} aria-hidden="true" /></span>
        <span className="mission-control-description">{description}</span>
      </a>
    ))}
    <a className="mission-control-github" href="#github" data-pointer-label="GitHub"><Github size={15} aria-hidden="true" /> Explore engineering work <ArrowUpRight size={15} aria-hidden="true" /></a>
  </nav>;
}
